import { MoneyConnectClientAPI } from "./axios-service-creator";

export const MasterAPI = {
  getAllConstant: () => MoneyConnectClientAPI.get("/common/master/getConstant"),
  getReceiveMethodList: () => MoneyConnectClientAPI.post("/common/master/searchReceiveMethod", {}),
  getBrokerList: () => MoneyConnectClientAPI.post("/common/master/searchBroker", {}),
  getIncomeSource: () => MoneyConnectClientAPI.post("/common/master/searchIncomeSource", {}),
  getLookupRegisterForm: () => MoneyConnectClientAPI.get("/common/master/getLookupRegisterform"),
  getCountryList: (payload) => MoneyConnectClientAPI.post("/common/master/searchCountry", payload ?? {}),
  getProvinceList: (payload) => MoneyConnectClientAPI.post("/common/master/searchProvince", payload ?? {}),
  searchDistrict: (payload) => MoneyConnectClientAPI.post("/common/master/searchDistrict", payload),
  searchSubDistrict: (payload) => MoneyConnectClientAPI.post("/common/master/searchSubDistrict", payload),
  getQuestion: () => MoneyConnectClientAPI.post("/common/master/searchQuestion", {}),
  searchTitle: () => MoneyConnectClientAPI.post("/common/master/searchTitle", {}),
  searchCountry: () => MoneyConnectClientAPI.post("/common/master/searchCountry", {}),
  searchPwmOccupation: () => MoneyConnectClientAPI.post("/common/master/searchPwmOccupation", {}),
  searchPwmBusinessType: () => MoneyConnectClientAPI.post("/common/master/searchPwmBusinessType", {}),
  searchPwmMonthlyIncome: () => MoneyConnectClientAPI.post("/common/master/searchPwmMonthlyIncome", {}),
};
